import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { CREATE_BENEFIT_GROUP_CATEGORY, CREATE_BENEFIT_GROUP_CATEGORY_SUCCESS, CREATE_BENEFIT_GROUP_CATEGORY_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* createBenefitGroupCategories({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefit-group-categories`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CREATE_BENEFIT_GROUP_CATEGORY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_BENEFIT_GROUP_CATEGORY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_BENEFIT_GROUP_CATEGORY_ERROR, payload: error });
  }
}

export function* watchBenefitGroupCategories() {
  yield takeEvery(CREATE_BENEFIT_GROUP_CATEGORY, createBenefitGroupCategories);
}

function* creatBenefitGroupCategoriesSaga() {
  yield all([fork(watchBenefitGroupCategories)]);
}

export default creatBenefitGroupCategoriesSaga;
